const localeSelectors = document.querySelectorAll(
  '[data-js="locale-selector"]'
);
Array.from(localeSelectors).forEach(elem => {
  elem.addEventListener('click', e => {
    e && e.preventDefault();
    e && e.stopPropagation();

    const dropdown = elem.parentNode.querySelector(
      '[data-js="locale-selector__dropdown"]'
    );

    if (dropdown.style.display === 'block') {
      dropdown.style.display = 'none';
    } else {
      dropdown.style.display = 'block';
    }
  });
});

document.addEventListener('click', () => {
  const localeDropdowns = document.querySelectorAll(
    '[data-js="locale-selector__dropdown"]'
  );
  Array.from(localeDropdowns).forEach(elem => {
    elem.style.display = 'none';
  });
});
